import stableStringify from '../../util/stableStringify';

const defaultOptions = {
  suspense: true,
  throwOnError: true,
  cacheTime: 5 * 60, // seconds
  stringifyInput: stableStringify,
  fetchPolicy: 'cache-or-network',
};

export default defaultOptions;
